import {
  convertCurrencyToSymbol,
  getTimeFormat,
} from "../../../../utils/CommonUtils";
import Strings from "../../../../resources/Strings";
import { PAYMENT_PART_NAMES, VALIDATION_DISCOUNT_TYPE } from "../../../../enums/Enums";
import classes from "./ParkingCostDetailsCard.module.css";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { Divider } from "@mui/material";
import { useSelector } from "react-redux";

import { LENGTHS } from "../../../../config/Config";

const ParkingCostDetailsCard = (props) => {
  const parkingSite = useSelector((state) =>
    state.user.sites.find((site) => {
      return site.id === props.parkingHistory.siteId;
    })
  );
  const entranceTime = getTimeFormat(new Date(props.parkingHistory.entranceDate), parkingSite.timeZone);
  const retrievalTime = getTimeFormat(new Date(props.parkingHistory.retrievalDate), parkingSite.timeZone);

  const invoiceSummary = props.utronUser?.invoiceSummaries?.find(
    (invoiceSummary) =>
      invoiceSummary.parkingHistoryId === props.parkingHistory.id
  );

  const foundedFullValidationHistory = props.parkingHistory?.validationsHistories?.find(vh => vh?.validationType === VALIDATION_DISCOUNT_TYPE.FULL && vh?.parkingHistoryId === props?.parkingHistory?.id);

  const carLicensePlate = props.utronUser?.cars.find(
    (car) => car.id === props.parkingHistory.carId
  )?.licensePlate;

  return (
    <div className={classes.parkingCostDetails}>
      <div className={classes.parkingItem}>
        <div className={classes.dateTime}>
          <div className={classes.text}>{Strings.ENTRANCE}</div>
          <div className={classes.time}>{entranceTime}</div>
        </div>
        <ArrowRightAltIcon className={classes.arrow} />
        {props.parkingHistory.retrievalDate && (
          <div className={classes.dateTime}>
            <div className={classes.text}>{Strings.EXIT}</div>
            <div className={classes.time}>{retrievalTime}</div>
          </div>
        )}
      </div>
      <Divider />
      <div className={classes.paymentParts}>
        <div className={classes.paymentPart}>
          <div className={classes.text}>{Strings.LICENSE_PLATE}</div>
          <div className={classes.total}>{carLicensePlate}</div>
        </div>

        {invoiceSummary ? invoiceSummary?.paymentParts.map(paymentPart => {
          if (paymentPart.name === 'Parking') {
            return (
              <div key={paymentPart.id} className={classes.paymentPart}>
                <div className={classes.text}>{PAYMENT_PART_NAMES.PARKING}</div>
                <div className={classes.total}>
                  {" "}
                  {`${convertCurrencyToSymbol(invoiceSummary.currency)}${parseFloat(paymentPart.total.toFixed(LENGTHS.TO_FIXED_LENGTH))
                    }`}
                </div>
              </div>
            );
          }
          if (paymentPart.name === 'Discount') {
            return (
              <div key={paymentPart.id} className={classes.paymentPart}>
                <div className={classes.text}>{PAYMENT_PART_NAMES.DISCOUNT}</div>
                <div className={classes.total}>
                  {" "}
                  {`-${convertCurrencyToSymbol(invoiceSummary.currency)}${parseFloat(paymentPart.total.toFixed(LENGTHS.TO_FIXED_LENGTH))
                    }`}
                </div>
              </div>
            );
          }
          else if (paymentPart.name === 'Ev charge' && paymentPart.total > 0) {
            return (
              <div key={paymentPart.id} className={classes.paymentPart}>
                <div className={classes.text}>{PAYMENT_PART_NAMES.EV_CHARGE}</div>
                <div className={classes.total}>
                  {" "}
                  {`${convertCurrencyToSymbol(invoiceSummary.currency)}${parseFloat(paymentPart.total.toFixed(LENGTHS.TO_FIXED_LENGTH))
                    }`}
                </div>
              </div>
            );
          }
          else if (paymentPart.name === 'Tax' && paymentPart.total > 0) {
            return (
              <div key={paymentPart.id} className={classes.paymentPart}>
                <div className={classes.text}>{PAYMENT_PART_NAMES.PARKING_TAX}</div>
                <div className={classes.total}>
                  {" "}
                  {`${convertCurrencyToSymbol(invoiceSummary.currency)}${parseFloat(paymentPart.total.toFixed(LENGTHS.TO_FIXED_LENGTH))
                    }`}
                </div>
              </div>
            );
          }
          else if (paymentPart.name === 'EvTax' && paymentPart.total > 0) {
            return (
              <div key={paymentPart.id} className={classes.paymentPart}>
                <div className={classes.text}>{PAYMENT_PART_NAMES.EV_TAX}</div>
                <div className={classes.total}>
                  {" "}
                  {`${convertCurrencyToSymbol(invoiceSummary.currency)}${parseFloat(paymentPart.total.toFixed(LENGTHS.TO_FIXED_LENGTH))
                    }`}
                </div>
              </div>
            );
          }
        }) : foundedFullValidationHistory &&
          (
            <>
              <div className={classes.paymentPart}>
                  <div className={classes.text}>{PAYMENT_PART_NAMES.PARKING}</div>
                  <div className={classes.total}>
                    {" "}
                    {`${convertCurrencyToSymbol(parkingSite?.billingCurrency)}${parseFloat(foundedFullValidationHistory?.validationAmount?.toFixed(LENGTHS.TO_FIXED_LENGTH))
                      }`}
                  </div>
                </div>
              <div className={classes.paymentPart}>
                  <div className={classes.text}>{PAYMENT_PART_NAMES.DISCOUNT}</div>
                  <div className={classes.total}>
                    {" "}
                    {`-${convertCurrencyToSymbol(parkingSite?.billingCurrency)}${parseFloat(foundedFullValidationHistory?.validationAmount?.toFixed(LENGTHS.TO_FIXED_LENGTH))
                      }`}
                  </div>
                </div>
            </>   
          )}

      </div>
      <Divider />
      {props.parkingHistory?.retrievalDate !== null &&
          <div className={classes.paymentParts}>
            <div className={classes.paymentPart}>
              {props.parkingHistory?.retrievalDate !== null &&
                <>
                  <div className={classes.total}>{Strings.TOTAL}</div>
                  {invoiceSummary ? (
                    <div className={classes.total}>
                      {`${convertCurrencyToSymbol(invoiceSummary.currency)}${parseFloat(invoiceSummary.finalPrice.toFixed(LENGTHS.TO_FIXED_LENGTH))}`}
                    </div>
                  ) :
                    <div className={classes.total}>
                      {`${convertCurrencyToSymbol(parkingSite?.billingCurrency)}0`}
                    </div>
                  }
                </>
              }
            </div>
          </div>
      }
    </div>
  );
};

export default ParkingCostDetailsCard;
